import { render, staticRenderFns } from "./LinkAddress.vue?vue&type=template&id=ea66a08a&"
import script from "./LinkAddress.vue?vue&type=script&lang=ts&"
export * from "./LinkAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports